import useAppStore from "@/context/store";
import { match } from "path-to-regexp";
import { parse } from "qs";

const URL_MAP = [
  {
    path: "/follow/:type?/:id?",
    name: "关注页",
    subName(router) {
      const type = router?.params?.type;

      const feedEl = document.querySelector("[data-new-feed]");
      if (feedEl) {
        const isNewFeed = feedEl.getAttribute("data-new-feed");
        const map = {
          board: "画板",
          user: "用户",
          domain: "来源",
          topic: "专题",
          job: "领域",
        };
        if (isNewFeed == "true") {
          return `新版Feed-${map[type] || "全部"}`;
        }
      }
      return "旧版Feed";
    },
  },
  {
    path: "/",
    name: "首页",
  },
  {
    path: "/popular/:url?",
    name: "榜单页",
  },
  {
    path: "/supernice",
    name: "超级可以_设计大会",
  },
  {
    path: "/coupons/:activityCode",
    name: "用户领券页",
  },
  {
    path: "/materials",
    name: "花瓣素材首页",
  },
  {
    path: "/discovery/:categoryId?/:type?",
    name: "发现页",
    subName(router) {
      const { type } = router.params;

      if (type === "boards") {
        return "画板";
      }
      return "采集";
    },
  },
  {
    path: "/search",
    name: "搜索结果页",
    subName(router) {
      const { type, subtype, urlname, borad_id, domain_id } = router.query;

      if (type === "board") {
        return "画板";
      }
      if (type === "user") {
        return "用户";
      }

      if (type === "material") {
        return "花瓣素材";
      }

      if (type === "aigc") {
        return "AIGC";
      }

      if (type === "following") {
        if (subtype === "board") return "关注画板";
        else return "关注用户";
      }

      if (urlname) {
        if (useAppStore.getState().user?.urlname === urlname) {
          if (subtype === "board") return "我的画板";
          else return "我的采集";
        } else {
          if (subtype === "board") return "他的画板";
          if (subtype === "pin") return "他的采集";
        }
      }

      if (borad_id) {
        return "画板内采集";
      }

      if (domain_id) {
        return "来源内采集";
      }

      if (type === "pin" || type === undefined) {
        return "采集";
      }
    },
  },
  {
    path: "/pins/:pinId",
    name: "采集详情页",
    subName() {
      const contetType = document
        .querySelector("[data-content-type]")
        ?.getAttribute("data-content-type");
      if (contetType) {
        return contetType;
      }
      return "普通采集";
    },
  },
  {
    path: "/boards/:boardId",
    name: "画板详情页",
    subName(router) {
      const { tab } = router.query;
      if (tab === "follow") return "被关注";
      return "采集";
    },
  },
  {
    path: "/boards/edit/:boardId",
    name: "画板批量管理",
  },
  {
    path: "/user/:urlname/following/:tabId?",
    name: "个人关注页",
    subName(router) {
      const { tabId } = router.params;
      if (tabId === "board") return "画板";
      if (tabId === "topic") return "专题";
      if (tabId === "job") return "领域";
      if (tabId === "domain") return "来源";
      return "用户";
    },
  },
  {
    path: "/user/:urlname/:openTab?/:tag?/:type?/:sub?",
    name: () => {
      const isMe = document.querySelector("#isMe");
      return `个人页_${isMe ? "自己" : "他人"}`;
    },
    subName(router) {
      const { openTab } = router.params;
      if (openTab === "pins") return "采集";
      if (openTab === "likes") return "喜欢";
      if (openTab === "tags") return "标签";
      if (openTab === "creations") return "原创";
      return "画板";
    },
  },
  {
    path: "/pins/:pinId/similar",
    name: "相似采集推荐页",
  },
  {
    path: "/pins/:pinId/similar/materials",
    name: "相似素材推荐页",
  },
  {
    path: "/vip/info",
    name: "会员页",
  },
  {
    path: "/vip/consult",
    name: "企业定制咨询页",
  },
  {
    path: "/me/right",
    name: "会员权益",
  },
  {
    path: "/me/download",
    name: "下载记录",
  },
  {
    path: "/me/order",
    name: "订单发票",
  },
  {
    path: "/guide",
    name: "新人引导页",
    subName() {
      const guideEl = document.querySelector("[data-new-guide]");
      if (guideEl) {
        return "新版引导页";
      }
      return "旧版引导页";
    },
  },
  {
    path: "/pins/:pinId/similar",
    name: "相似采集推荐页",
  },
  {
    path: "/explore/:topic",
    name: "专题页",
  },
  {
    path: "/settings",
    name: "个人设置页",
    subName(router) {
      const { tab } = router.query;
      switch (tab) {
        case "account":
          return "设置账号";
        case "password":
          return "修改密码";
        case "privacy":
          return "设置隐私";
        case "message":
          return "屏蔽私信";
        default:
          return "个人资料";
      }
    },
  },
  {
    path: "/activities",
    name: "大赛页面",
  },
  {
    path: "/activities/start",
    name: "发起大赛页",
  },
  {
    path: "/about",
    name: "关于花瓣页",
  },
  {
    path: "/about/goodies",
    name: "浏览器采集工具页",
  },
  {
    path: "/about/contact",
    name: "联系我们页",
  },
  {
    path: "/app",
    name: "App下载页",
  },
  {
    path: "/go",
    name: "第三方中转页",
  },
  {
    path: "/from/:urlname",
    name: "第三方来源页",
  },
  {
    path: "/favorite/:urlname",
    name: "喜欢页",
  },
  {
    path: "/muse/certify",
    name: "认证设计师申请",
  },
  {
    path: "/muse/register",
    name: "认证设计师",
  },
  {
    path: "/cooperator/:urlname",
    name: "独家合作",
  },
  {
    path: "/history/:type?",
    name: "浏览记录",
  },
  {
    path: "/vip/consult",
    name: "大企业咨询页面",
  },
  {
    path: "/ai",
    name: "ai圈页面",
  },
  {
    path: "/calendars/:festival",
    name: "热点日历聚合页",
  },
  {
    path: "/calendars",
    name: "热点日历聚合页",
  },
  {
    path: "/share",
    name: "新第三方分享页",
    subName(router) {
      const { type } = router.query;
      return type == "aigc" ? "AI采集" : "普通采集";
    },
  },
  {
    path: "/topics/:urlname",
    name: "主题页",
    subName() {
      const name = document.querySelector("h1")?.innerText;
      const subName = document.querySelector("h2")?.innerText;
      return name && subName ? `${name}_${subName}` : "";
    },
  },
  {
    path: "/oauth/authorize",
    name: "第三方授权页",
  },
  {
    path: "/login",
    name: "登录页",
  },
];
/**
 * @returns {{
 *  page_nm: string,
 *  sub_page_nm?: string
 * }}
 */
export default function getPageData() {
  try {
    for (let i = 0; i < URL_MAP.length; i++) {
      const rule = URL_MAP[i];
      const result = match(rule.path)(window.location.pathname);
      // result.query = parse(window.location.search);
      // console.log(
      //   "getPageData - parse(window.location.search)",
      //   parse(window.location.search)
      // );

      // console.log(result);
      if (result) {
        result.query = window.location.search
          ? parse(window.location.search.substring(1))
          : {};
        const page = {
          page_nm:
            typeof rule.name === "function" ? rule.name(result) : rule.name,
          page_params: result.query,
        };
        if (rule.subName) {
          page.sub_page_nm =
            typeof rule.subName === "function"
              ? rule.subName(result)
              : rule.subName;
        }

        return page;
      }
    }

    return {
      page_nm: "未识别",
    };
  } catch (error) {
    error.message = "获取页面信息失败: " + error.message;
    console.error(error);
    return {};
  }
}
